<!--
 * @Description: 退出登录
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-06 13:46:06
 -->

<template>
  <div style="display: inline-block;" >
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      top
    >
      <template v-slot:activator="{ on }">
        <v-btn text icon color="indigo" v-on="on">
              <v-icon>tag_faces</v-icon>
          </v-btn>
      </template>
      <v-card width="400">
        <v-list  >
          <v-list-item>
            <v-list-item-content class="emoji__">
                  <v-tooltip  top v-for="(item, index) in valueList" :key="index">
                    <template v-slot:activator="{ on }">
                        <span color="primary" dark v-on="on" @click="submit(index)">{{item}}</span>
                    </template>
                    <span>{{ item }}</span>
                  </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
    name:'emoji',
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      dialog: false,
      valueText:'',
      valueList: [
        '😀','😄','😁','😆','😅','😂','🙂','🙃','😉','😊','😇','😍','😘','😗','😙','😚','😋','😛','😜','😝',
        '🤐','😐','😶','😏','🙄','😬','🤥','😪','🤤','😷','😵','🤠','😎','🤓','😦','😧','😥','😢','😢','😱',
        '😃','😖','😤','😡','😠','😈','💩','💀','🤡','👹','😺','😸','😹','😻','😼','😽','😿','🙀','👋','🤚',
        '🖐','✋','🖖','👌','✌','🤞','🤘','🤙','👈','👉','👆','👇','☝','👍','🤝','🔥','💡','🙋','💪'
      ]
    };
  },
 
   mounted: function() {},
  methods: {
      /* 发送 */   
      submit(index){
          this.$parent.$parent.$parent.quick_emoji( this.valueList[index] );
      }
  }
};
</script>

<style lang="scss" scoped>
.emoji__>span{
  display: contents;
  width: 50px;
  font-size: 25px;
  padding: 5px;
  cursor:pointer
}
.v-menu__content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.v-menu__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.6);
  height: 120px;
}

.v-menu__content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.1);
}

.v-menu__content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  background: #ebeef5;
  -webkit-box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.2);
}

.v-menu__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.2);
  height: 120px;
}

.v-menu__content::-webkit-scrollbar-track{
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  border-radius: 2px;
  background: #fff;
}
</style>